/** @file TimelineHeader: the playhead clip's name, category, length, timing, loop and facing. */
import type { ReactElement } from 'react';
import { useEditor } from '../../state/useEditor';
import { clipDuration } from './clipDuration';
import { usePlayheadClip } from './usePlayheadClip';

/** One line of facts about the clip (or a hint when none is picked; the rest pose when the puppet has no clips). */
export function TimelineHeader(): ReactElement {
  const cur = usePlayheadClip();
  const none = useEditor((s) => Object.keys(s.puppet.doc?.clips ?? {}).length === 0);
  const muted = { color: 'var(--muted, #8b919e)' };
  if (cur === null) return <div style={{ ...muted, padding: '4px 8px' }}>{none ? 'Rest pose (A-pose): no clips yet' : 'No clip: pick one on the left'}</div>;
  const { clip } = cur;
  const loop = clip.loop ? `loop from ${clip.loopStart}` : 'one-shot';
  return (
    <div style={{ display: 'flex', gap: 10, padding: '4px 8px', alignItems: 'baseline' }}>
      <strong>{cur.name}</strong>
      <span style={muted}>{clip.category}</span>
      <span style={muted}>{clip.frames} frames @ {clip.fps} fps = {clipDuration(clip).toFixed(2)} s</span>
      <span style={muted}>{loop}</span>
      {clip.facingSteps !== undefined && <span style={muted}>facing {clip.facingSteps}</span>}
    </div>
  );
}
